module.exports = __webpack_public_path__ + "static/img/content_bg_id.07f827c7.png";